import { render } from "./ScheduleAgendaItem.vue?vue&type=template&id=10dbd756&scoped=true"
import script from "./ScheduleAgendaItem.vue?vue&type=script&lang=js"
export * from "./ScheduleAgendaItem.vue?vue&type=script&lang=js"

import "./ScheduleAgendaItem.vue?vue&type=style&index=0&id=10dbd756&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dbd756"]])

export default __exports__